import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Box from "@material-ui/core/Box";
import WarningIcon from "@material-ui/icons/Warning";
import CancelIcon from "@material-ui/icons/Cancel";
import { Grid, Typography } from "@material-ui/core";
import warningDel from "assets/images/confirm/warning_del.png";
import infoIcon from "assets/images/confirm/infoIcon.svg";

export interface ConfirmationDialogRawProps {
    id: string;
    keepMounted: boolean;
    value?: "info" | "warn" | "error" | "delete"; // Specific value types for better type safety
    open: boolean;
    onClose: (isOk?: boolean, isClose?: boolean) => void;
    title: string;
    content: React.ReactNode | string; // Allow content to be a string or ReactNode
    active?: boolean;
    labelOk?: string;
    labelCancel?: string;
    component?: React.ReactNode; // Specified as ReactNode for clarity
}

export const ConfirmationDialogRaw: React.FC<ConfirmationDialogRawProps> = ({
    onClose,
    open,
    labelOk,
    labelCancel,
    component,
    active,
    id,
    keepMounted,
    title,
    content,
    value
}) => {
    // Font properties
    let fontColor = "black";
    let fontFamily = "Arial";
    let fontSize = 13;
    let width: "xs" | "sm" | "md" | "lg" | "xl" | false = "xs"; // Default value

    return (
        <Dialog
            // disableEscapeKeyDown
            fullWidth
            maxWidth={width}
            aria-labelledby="confirmation-dialog-title"
            open={open}
        >
            <DialogTitle id={id}>
                <Box display="flex" flexDirection="column" alignItems="center" marginTop={2}>
                    {value === "delete" && (
                        <img src={warningDel} alt="warning delete" width={50} height={50} />
                    )}
                    {value === "info" && (
                        <img src={infoIcon} alt="warning delete" width={50} height={50} />
                    )}
                    <Typography
                        style={{
                            fontWeight: 500,
                            marginTop: 10,
                            textAlign: "center",
                            fontSize: 16
                        }}
                    >
                        {title}
                    </Typography>
                    {/* <IconButton onClick={() => onClose(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton> */}
                </Box>
            </DialogTitle>
            <DialogContent>
                {component}
                <Box style={{ display: "flex", alignItems: "center", color: fontColor, fontFamily, fontSize, marginBottom: 20 }}>
                    {/* {value === "info" && (
                        <InfoIcon color="primary" style={{ marginRight: 5, fontSize }} />
                    )} */}
                    {value === "warn" && (
                        <WarningIcon style={{ color: "#ffd600", marginRight: 5, fontSize }} />
                    )}
                    {value === "error" && (
                        <CancelIcon color="secondary" style={{ marginRight: 5, fontSize }} />
                    )}
                    {typeof content === "string" ? (
                        <span
                            style={{
                                fontWeight: 400,
                                fontSize: 14,
                                textAlign: "center",
                                color: "#69686D",
                                width: "100%",
                            }}
                        >
                            {content}
                        </span>
                    ) : (
                        content
                    )}
                </Box>
            </DialogContent>
            <DialogActions
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                }}
            >
                <Button variant="contained" disableElevation onClick={() => onClose(true)}
                    style={{
                        // backgroundColor: "#0091FF",
                        backgroundColor: `${value === "delete" ? "#FF0004" : "#0091FF"}`,
                        color: "#FFFFFF",
                        minWidth: 360,
                        marginBottom: 5
                    }}
                >
                    <span
                        style={{
                            fontWeight: 500,
                            fontSize: 16,
                        }}
                    >
                    {labelOk || "Xác nhận"}
                    </span>
                </Button>
                <Button color="default" disableElevation onClick={() => onClose(false)}
                    style={{
                        // fontWeight: 500,
                        minWidth: 360,
                        backgroundColor: "#ffffff",
                    }}
                >
                    <span
                        style={{
                            fontWeight: 500,
                            fontSize: 14,
                        }}
                    >
                        {labelCancel || "Hủy"}
                    </span>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
